<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header v-if="!vistaModal" />

    <b-container fluid  style="background-color: white !important;">

      <b-row class="detalle-formulario mt-4" v-if="!vistaModal">
        <b-col cols="12">
          <em class="cita_svg color-icono-modal" style="height: 20px;"></em>
          <label class="detalle-formulario-h1 ml-1" v-if="datosPreCita.citaReagendar">Reagendar cita</label>
          <label class="detalle-formulario-h1 ml-1" v-else>Agendar cita</label>
        </b-col>
      </b-row>

      <busquedaPaciente @seleccionarPaciente="seleccionarPaciente"
                        :idPaciente="datosPreCita.idPaciente" :datos-calendario="datosCalendario" @continuarCita="continuarProceso" @editarDatosContacto="editarDatosContacto" />


      <informacionCitaPaciente v-show="datosContactoPaciente"
          :infoPac="datosCita"
          :editarFull="editarFull"
          :deshabilitarTodo="deshabilitarTodo"
          :citaSobreAgendar="citaSobreAgendar"
          :idClinica="idClinica"
          :empleadosEsp="empleadosEsp"
          @cerrarModal="cerrarModal"
          @guardarNuevaCitaV2="guardarNuevaCitaV2"
          />



    </b-container>

  </div>
</template>

<script>
import busquedaPaciente from "@/components/NuevaAgenda/nuevaCita/busquedaPaciente";
import informacionCitaPaciente from "@/components/NuevaAgenda/nuevaCita/informacionCitaPaciente";
import {DatosCita} from "@/components/NuevaAgenda/nuevaCita/DatosCita";

import Header from "@/components/Header.vue";

export default {
  name: "nuevaCita",
  components: {
    busquedaPaciente,
    informacionCitaPaciente,
    Header
  },
  props:{
    vistaModal: {
      type: Boolean,
      default: false
    },
    idClinica: {
      type: Number,
      default: 42
    },
    datosPreCita: Object,
    empleadosEsp: Array,
    datosCalendario: Object,
  },
  data:() =>({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    datosCita: null,
    editarFull: true,
    deshabilitarTodo: true,
    citaSobreAgendar: false,
    datosContactoPaciente: false,
  }),
  watch:{

  },
  computed:{

  },
  methods: {

    seleccionarPaciente(datosCita) {
      this.datosCita.idPaciente = datosCita.idPaciente;
      this.datosCita.nombrePaciente = datosCita.nombrePaciente;
      this.datosCita.esPacienteNuevo = datosCita.idTipoPaciente == 1;
      this.datosCita.idTipoPaciente = datosCita.idTipoPaciente;
      this.datosCita.tipoPaciente = datosCita.tipoPaciente;
      this.datosCita.idSexo = datosCita.idSexo;
      this.datosCita.celular = datosCita.telefono;
      this.datosCita.correo = datosCita.correo;
      this.datosCita.ptiActivo = datosCita.ptiActivo;
      this.datosCita.fechaNacimientoCompleta = datosCita.fechaNacimientoCompleta;
      this.datosCita.confianza = datosCita.confianza;
      this.datosCita.ultimoTratamiento = datosCita.ultimoTratamiento;
      this.datosCita.esPacienteVIP = datosCita.esPacienteVIP;
      this.deshabilitarTodo = false;

      if (this.datosCita.citaEdicion === undefined
        || this.datosCita.citaEdicion === null || !this.datosCita.citaEdicion) {
        this.datosCita.idTagMotivoCita = null;
      }

    },

    guardarNuevaCitaV2(datosActualizacion) {
      this.$emit('guardarNuevaCitaV2', datosActualizacion)
    },

    cerrarModal() {
      if (this.vistaModal) {
        this.$emit('cerrarModal')
      }
    },

    continuarProceso(boolean) {
      this.datosContactoPaciente = boolean;
    },

    editarDatosContacto(){
      this.datosContactoPaciente = false;
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.datosCita = new DatosCita();

    if (this.datosPreCita !== null) {

      if (this.datosPreCita.sillon !== undefined && this.datosPreCita.sillon !== null) {
        this.datosCita.sillon = this.datosPreCita.sillon;
      }

      if (this.$localStorageService.can("CA_06_crear_cita_embajador") &&
          (this.datosPreCita.citaEmbajador || this.datosPreCita.sillon >= 100)) {
          this.datosPreCita.sillon = 100;
          this.datosCita.citaEmbajador = true;
      }

      if (
          this.datosPreCita.idEspecialidad !== undefined &&
          this.datosPreCita.idEspecialidad !== null
      ) {
        this.datosCita.idEspecialidad = this.datosPreCita.idEspecialidad;
      }

      if (
          this.datosPreCita.idEmpleado !== undefined &&
          this.datosPreCita.idEmpleado !== null
      ) {
        this.datosCita.idEmpleado = this.datosPreCita.idEmpleado;
      }

      if (
          this.datosPreCita.fechaCita !== undefined &&
          this.datosPreCita.fechaCita !== null
      ) {
        this.datosCita.fechaCita = this.datosPreCita.fechaCita;
      }

      if (
          this.datosPreCita.horaInicio !== undefined &&
          this.datosPreCita.horaInicio !== null
      ) {
        this.datosCita.horaInicio = this.datosPreCita.horaInicio;
      }

      if (
          this.datosPreCita.citaDesdeCal !== undefined &&
          this.datosPreCita.citaDesdeCal !== null
      ) {
        this.datosCita.citaDesdeCal = this.datosPreCita.citaDesdeCal;
      }

      if (
          this.datosPreCita.comentario !== undefined &&
          this.datosPreCita.comentario !== null
      ) {
        this.datosCita.comentario = this.datosPreCita.comentario;
      }

      if (
          this.datosPreCita.comentarioFijo !== undefined &&
          this.datosPreCita.comentarioFijo !== null
      ) {
        this.datosCita.comentarioFijo = this.datosPreCita.comentarioFijo;
      }

      if (
          this.datosPreCita.citaAdministrativa !== undefined &&
          this.datosPreCita.citaAdministrativa !== null
      ) {
        this.datosCita.citaAdministrativa = this.datosPreCita.citaAdministrativa;
      }

      this.deshabilitarTodo = true;

      if ( this.datosPreCita.citaEdicion!== undefined && this.datosPreCita.citaEdicion) {
        this.deshabilitarTodo = false;
        this.datosCita.citaEdicion = true;

        if (
            this.datosPreCita.citaReagendar !== undefined &&
            this.datosPreCita.citaReagendar !== null
        ) {
          this.datosCita.citaReagendar = this.datosPreCita.citaReagendar;
        }

        if (
            this.datosPreCita.citaListaEspera !== undefined &&
            this.datosPreCita.citaListaEspera !== null
        ) {
          this.datosCita.citaListaEspera = this.datosPreCita.citaListaEspera;
        }

        if (
            this.datosPreCita.idCita !== undefined &&
            this.datosPreCita.idCita !== null
        ) {
          this.datosCita.idCita = this.datosPreCita.idCita;
        }

        if (
            this.datosPreCita.idListaEspera !== undefined &&
            this.datosPreCita.idListaEspera !== null
        ) {
          this.datosCita.idListaEspera = this.datosPreCita.idListaEspera;
        }

        if (
            this.datosPreCita.idTagMotivoCita !== undefined &&
            this.datosPreCita.idTagMotivoCita !== null
        ) {
          this.datosCita.idTagMotivoCita = this.datosPreCita.idTagMotivoCita;
        }

        if (
            this.datosPreCita.idEspecialidad !== undefined &&
            this.datosPreCita.idEspecialidad !== null
        ) {
          this.datosCita.idEspecialidad = this.datosPreCita.idEspecialidad;
        }

        if (
            this.datosPreCita.tratamientos !== undefined &&
            this.datosPreCita.tratamientos !== null
        ) {
          this.datosCita.tratamientos = this.datosPreCita.tratamientos;
          this.datosCita.tratamientos.forEach(it=>it.visible = true);
        }


      }

      if ( this.datosPreCita.citaSobreAgendar!== undefined && this.datosPreCita.citaSobreAgendar) {
        this.citaSobreAgendar = this.datosPreCita.citaSobreAgendar;
      }

    }

  },
}
</script>

<style scoped>

</style>
